var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"partner"},[_c('div',{staticClass:"partner-wrapper"},[_c('div',{staticClass:"partner-title"},[_vm._v("我们的伙伴")]),_c('PartnerCarousels',{attrs:{"data":_vm.partners}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }